export default __webpack_public_path__ + "static/media/908.d46feaf2.gif";